<template>
  <footer class="footer">
    <div class="container">
      <span class="text-muted">&copy; 2019 Cloudflare, Inc.</span>
      <div>
        <a class="text-muted" href="https://www.cloudflare.com/privacypolicy/">Privacy Policy</a>
        <a class="text-muted" href="https://www.cloudflare.com/website-terms/">Terms of Use</a>
        <a class="text-muted" href="https://www.cloudflare.com/abuse/">Trust & Safety</a>
        <a class="text-muted" href="https://www.cloudflare.com/trademark/">Trademark</a>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footbar',
  }
</script>

<style>
  html {
    position: relative;
    min-height: 100%;
  }
  body {
    margin-bottom: 60px;
  }
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    min-height: 60px;
    line-height: 60px;
    background-color: #f3f6f8;
    text-align: right;
  }
  .footer div {
    display: inline;
  }
  .footer a {
    padding: 0 7px;
    border-left: 1px solid #cac8c8;
  }
  .footer a:link {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Footbar.vue